import React from 'react'

function Exchange ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='16' height='14.492' viewBox='0 0 16 14.492'>
      <g transform='translate(16 -0.066) rotate(90)'>
        <path d='M291.266,20.251V4.4h.714V18.529L295.509,15l.5.5Zm0,0' transform='translate(-281.455 -4.251)' />
        <path d='M4.814,15.853H4.1V1.722L.571,5.252l-.5-.5L4.814,0Zm0,0' />
      </g>
    </svg>
  )
}

Exchange.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Exchange
